export const menuItems = [
    {
        title: "Data Pasien",
        icon: "fa fa-users",
        children: [
            {
                title: "Master Pasien",
                to: "/update-pasien",
                icon: "fa fa-user-circle",
            },
            {
                title: "Merge Pasien",
                to: "/merge-data-pasien",
                icon: "fa fa-users",
            },
            {
                title: "Non Aktif Pasien",
                to: "/nonaktif-data-pasien",
                icon: "fa fa-user-times",
            },
            {
                title: "Ganti Nomor RM",
                to: "/ganti-nomor-rm",
                icon: "fa fa-refresh",
            },
            {
                title: "Scan Berkas RM",
                to: "/scan-berkas-rm",
                icon: "fa fa-file-archive-o",
            },
            {
                title: "Ganti No Registrasi",
                to: "/ganti-registrasi",
                icon: "fa fa-refresh",
            },
            {
                title: "Update Kategori & Cara Bayar",
                to: "/update-kategori-cara-bayar",
                icon: "fa fa-refresh",
            },
        ],
    },
    {
        title: "Retensi dan Pemusnahan",
        icon: "fa fa-archive",
        children: [
            {
                title: "Pasien Tidak Aktif 5 Tahun",
                to: "/pasien-tidak-aktif-5-tahun",
                icon: "fa fa-user-times",
            },
            {
                title: "Data MR Tidak Aktif",
                to: "/data-mr-tidak-aktif",
                icon: "fa fa-user-times",
            },
            {
                title: "Laporan Retensi dan Pemusnahan",
                to: "/laporan-retensi-dan-pemusnahan",
                icon: "fa fa-file-text-o",
            },
        ],
    },
    {
        title: "Tracking Pasien",
        icon: "fa fa-search",
        children: [
            {
                title: "Pasien Check-In",
                to: "/pasien-check-in",
                icon: "fa fa-sign-in",
            },
            {
                title: "Konsul Antar Poli",
                to: "/konsul-antar-poli",
                icon: "fa fa-bullhorn",
            },
            {
                title: "Sensus Harian Pasien",
                to: "/sensus-harian-pasien",
                icon: "fa fa-bed",
            },
            {
                title: "Pasien Meninggal",
                to: "/pasien-meninggal",
                icon: "fa fa-user-times",
            },
            {
                title: "Selesai Pelayanan",
                to: "/selesai-pelayanan",
                icon: "fa fa-clock-o",
            },
            {
                title: "Pencarian Pelayanan Pasien",
                to: "/pencarian-pasien",
                icon: "fa fa-search",
            },
            {
                title: "Riwayat Pasien",
                to: "/riwayat-pasien",
                icon: "fa fa-history",
            },
        ],
    },
    {
        title: "Monitoring Pasien",
        icon: "fa fa-heartbeat",
        children: [
            {
                title: "File Status Keluar",
                to: "/file_status_keluar",
                icon: "fa fa-sign-out",
            },
            {
                title: "File Status Masuk",
                to: "/file_status_masuk",
                icon: "fa fa-sign-in",
            },
            {
                title: "File Status Belum Kembali",
                to: "/file_status_belum_kembali",
                icon: "fa fa-clock-o",
            },
            {
                title: "Monitoring File Status",
                to: "/monitoring_file_status",
                icon: "fa fa-search",
            },
        ],
    },
    {
        title: "ICD X & ICD 9",
        icon: "fa fa-file-medical",
        children: [
            {
                title: "Master ICD X",
                to: "/master-icdx",
                icon: "fa fa-file-medical-alt",
            },
            {
                title: "Master ICD 9",
                to: "/master-icd9",
                icon: "fa fa-file-medical-alt",
            },
            {
                title: "Input ICD Pasien",
                to: "/pasien-icd",
                icon: "fa fa-user",
            },
        ],
    },
    {
        title: "Laporan External",
        icon: "fa fa-file-export",
        children: [
            {
                title: "Data Dasar Rumah Sakit",
                to: "/external-rs",
                icon: "fa fa-hospital",
            },
            {
                title: "Indikator Pelayanan",
                to: "/external-pelayanan",
                icon: "fa fa-chart-line",
            },
            {
                title: "Tempat Tidur",
                to: "/external-tempat-tidur",
                icon: "fa fa-bed",
            },
            {
                title: "Ketenagaan",
                to: "/external-ketenagaan",
                icon: "fa fa-users",
            },
            {
                title: "Rawat Inap",
                to: "/external-ranap",
                icon: "fa fa-procedures",
            },
            {
                title: "Rawat Darurat",
                to: "/external-darurat",
                icon: "fa fa-ambulance",
            },
            {
                title: "Kesehatan Gigi dan Mulut",
                to: "/external-gigi-mulut",
                icon: "fa fa-tooth",
            },
            {
                title: "Pengunjung",
                to: "/external-pengunjung",
                icon: "fa fa-user-friends",
            },
            {
                title: "Kunjungan Rawat Jalan",
                to: "/external-kunjungan-rajal",
                icon: "fa fa-clipboard-list",
            },
            {
                title: "25 Besar Penyakit Rawat Inap",
                to: "/external-penyakit-ranap",
                icon: "fa fa-list-ol",
            },
            {
                title: "25 Besar Penyakit Rawat Jalan",
                to: "/external-penyakit-rajal",
                icon: "fa fa-list-ol",
            },
        ],
    },
    {
        title: "Formulir RL 1",
        icon: "fa fa-hospital-symbol",
        children: [
            {
                title: "RL 1.1 Profil Rumah Sakit",
                to: "/identitas-rumah-sakit/profil-rumah-sakit",
                icon: "fa fa-file-alt",
            },
            {
                title: "RL 1.2 Ketersediaan Pelayanan",
                to: "/identitas-rumah-sakit/ketersediaan-pelayanan",
                icon: "fa fa-clipboard-check",
            },
            {
                title: "RL 1.3 Ketersediaan Tempat Tidur",
                to: "/identitas-rumah-sakit/ketersediaan-tempat-tidur",
                icon: "fa fa-bed",
            },
        ],
    },
    {
        title: "Formulir RL 3",
        icon: "fa fa-chart-bar",
        children: [
            {
                title: "RL 3.1 Indikator Pelayanan",
                to: "/rekapitulasi-pelayanan/indikator-pelayanan",
                icon: "fa fa-chart-line",
            },
            {
                title: "RL 3.2 Rekapitulasi Kegiatan Pelayanan Rawat Inap",
                to: "/rekapitulasi-pelayanan/kegiatan-pelayanan-rawat-inap",
                icon: "fa fa-procedures",
            },
            {
                title: "RL 3.3 Rekapitulasi Kegiatan Pelayanan Rawat Darurat",
                to: "/rekapitulasi-pelayanan/kegiatan-pelayanan-rawat-darurat",
                icon: "fa fa-ambulance",
            },
            {
                title: "RL 3.4 Rekapitulasi Pengunjung",
                to: "/rekapitulasi-pelayanan/rekapitulasi-jumlah-pengunjung",
                icon: "fa fa-user-friends",
            },
            {
                title: "RL 3.5 Rekapitulasi Kunjungan",
                to: "/rekapitulasi-pelayanan/rekapitulasi-jumlah-kunjungan",
                icon: "fa fa-clipboard-list",
            },
            {
                title: "RL 3.6 Rekapitulasi Kegiatan Pelayanan Kebidanan",
                to: "/rekapitulasi-pelayanan/kegiatan-pelayanan-kebidanan",
                icon: "fa fa-baby",
            },
            {
                title: "RL 3.7 Rekapitulasi Kegiatan Pelayanan Neonatal",
                to: "/rekapitulasi-pelayanan/kegiatan-pelayanan-neonatal",
                icon: "fa fa-baby-carriage",
            },
            {
                title: "RL 3.8 Rekapitulasi Kegiatan Pelayanan Laboratorium",
                to: "/rekapitulasi-pelayanan/kegiatan-pelayanan-laboratorium",
                icon: "fa fa-flask",
            },
            {
                title: "RL 3.9 Rekapitulasi Kegiatan Pelayanan Radiologi",
                to: "/rekapitulasi-pelayanan/kegiatan-pelayanan-radiologi",
                icon: "fa fa-x-ray",
            },
            {
                title: "RL 3.10 Rekapitulasi Kegiatan Pelayanan Rujukan",
                to: "/rekapitulasi-pelayanan/kegiatan-pelayanan-rujukan",
                icon: "fa fa-exchange-alt",
            },
            {
                title: "RL 3.11 Rekapitulasi Kegiatan Pelayanan Gigi dan Mulut",
                to: "/rekapitulasi-pelayanan/kegiatan-pelayanan-gigi-dan-mulut",
                icon: "fa fa-tooth",
            },
            {
                title: "RL 3.12 Rekapitulasi Kegiatan Pelayanan Pembedahan",
                to: "/rekapitulasi-pelayanan/kegiatan-pelayanan-pembedahan",
                icon: "fa fa-scalpel",
            },
            {
                title: "RL 3.13 Rekapitulasi Kegiatan Pelayanan Rehabilitasi Medik",
                to: "/rekapitulasi-pelayanan/kegiatan-pelayanan-rehabilitasi-medik",
                icon: "fa fa-wheelchair",
            },
            {
                title: "RL 3.14 Rekapitulasi Kegiatan Pelayanan Khusus",
                to: "/rekapitulasi-pelayanan/kegiatan-pelayanan-khusus",
                icon: "fa fa-star",
            },
            {
                title: "RL 3.15 Rekapitulasi Kegiatan Pelayanan Kesehatan Jiwa",
                to: "/rekapitulasi-pelayanan/kegiatan-pelayanan-kesehatan-jiwa",
                icon: "fa fa-brain",
            },
            {
                title: "RL 3.16 Rekapitulasi Kegiatan Pelayanan Keluarga Berencana ",
                to: "/rekapitulasi-pelayanan/kegiatan-pelayanan-keluarga-berencana",
                icon: "fa fa-user-friends",
            },
            {
                title: "RL 3.17 Rekapitulasi Kegiatan Pelayanan Farmasi RS - Pengadaan Obat ",
                to: "/rekapitulasi-pelayanan/kegiatan-pelayanan-farmasi-rs-pengadaan-obat",
                icon: "fa fa-medkit",
            },
            {
                title: "RL 3.18 Rekapitulasi Kegiatan Pelayanan Farmasi Rumah Sakit - Resep ",
                to: "/rekapitulasi-pelayanan/kegiatan-pelayanan-farmasi-rumah-sakit-resep",
                icon: "fa fa-medkit",
            },
            {
                title: "RL 3.19 Rekapitulasi Cara Bayar",
                to: "/rekapitulasi-pelayanan/rekapitulasi-cara-bayar",
                icon: "fa fa-credit-card",
            },
            {
                title: "Daftar Rujukan Pasien",
                to: "/rekapitulasi-pelayanan/daftar-rujukan",
                icon: "fa fa-exchange-alt",
            },
        ],
    },
    {
        title: "Formulir RL 4",
        icon: "fa fa-clipboard-list",
        children: [
            {
                title: "RL 4.1 Kompilasi Morbiditas Pasien Rawat Inap",
                to: "/rekapitulasi-morbiditas/rawat-inap",
                icon: "fa fa-list",
            },
            {
                title: "RL 4.2 10 Besar Penyakit Rawat Inap",
                to: "/rekapitulasi-morbiditas/10-besar-penyakit-rawat-inap",
                icon: "fa fa-list-ol",
            },
            {
                title: "RL 4.3 10 Besar Kematian Penyakit Rawat Inap ",
                to: "/rekapitulasi-morbiditas/10-besar-kematian-rawat-inap",
                icon: "fa fa-list-ol",
            },
        ],
    },
    {
        title: "Formulir RL 5",
        icon: "fa fa-clipboard-list",
        children: [
            {
                title: "RL 5.1 Kompilasi Morbiditas Pasien Rawat Jalan",
                to: "/rekapitulasi-morbiditas/rawat-jalan",
                icon: "fa fa-list",
            },
            {
                title: "RL 5.2 10 Besar Kasus Baru Penyakit Rawat Jalan",
                to: "/rekapitulasi-morbiditas/10-besar-penyakit-rawat-jalan",
                icon: "fa fa-list-ol",
            },
            {
                title: "RL 5.3 10 Besar Kunjungan Penyakit Rawat Jalan",
                to: "/rekapitulasi-morbiditas/10-besar-kunjungan-penyakit-rawat-jalan",
                icon: "fa fa-list-ol",
            },
        ],
    },
];
